var _span;
import { clsx } from 'clsx';
import QuestionMarkCircle from '@crehana/compass.icons.fill/QuestionMarkCircle';
import { Tooltip } from "../Tooltip";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * This component doesn't have/use a `label` tag. This is just the content of the label that an input should use.
 * Don't forget to wrap it with a `label` tag.
 *
 * I.e: `<label><BaseInputLabelText ....props /></label>`
 */
export var BaseInputLabelText = function BaseInputLabelText(_ref) {
  var disabled = _ref.disabled,
    tooltip = _ref.tooltip,
    label = _ref.label,
    _ref$sizeType = _ref.sizeType,
    sizeType = _ref$sizeType === void 0 ? 'large' : _ref$sizeType,
    className = _ref.className;
  var isSmall = sizeType === 'small';
  return /*#__PURE__*/_jsxs("span", {
    className: clsx('tw-flex tw-items-center', className),
    children: [/*#__PURE__*/_jsx("span", {
      className: clsx('tw-mr-0.8', {
        'tw-font-subtitle5': isSmall,
        'tw-font-subtitle4': !isSmall,
        'dark:tw-text-neutral-dark-600': disabled,
        'dark:tw-text-neutral-light-100': !disabled
      }),
      children: label
    }), tooltip && /*#__PURE__*/_jsx(Tooltip, {
      position: "right",
      label: tooltip,
      type: "small",
      children: _span || (_span = /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(QuestionMarkCircle, {
          className: "tw-text-neutral-light-600",
          size: 16
        })
      }))
    })]
  });
};
export default BaseInputLabelText;